import { useGetCurrentUserSuspenseQuery } from "#lib/useGetCurrentUserSuspenseQuery.ts";
import type { FeatureFlag } from "#types/types.ts";
import { useCallback } from "react";

export const useFeatureFlag = () => {
    const { data: { featureFlags } } = useGetCurrentUserSuspenseQuery();

    const hasFeatureFlag = useCallback((...flags: FeatureFlag[]) => flags.every(flag => featureFlags.includes(flag)), [featureFlags]);

    return { hasFeatureFlag };
};
